var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMl = function SvgMl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c92c0da5-2084-4472-80b5-384945955866a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c1000734-4c66-4f65-bda7-e21984ee6c1ab",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c1000734-4c66-4f65-bda7-e21984ee6c1ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDD200",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B731",
    fillRule: "evenodd",
    d: "M0 0h7v15H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0091E",
    fillRule: "evenodd",
    d: "M14 0h7v15h-7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c92c0da5-2084-4472-80b5-384945955866a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgMl;